import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Login from './Login/Login'
import Home from './Home/Home'
import IssueBadge from './IssueBadge/IssueBadge'
import AllBadges from './AllBadges/AllBadges'
import User from './User/User'
import BadgeInfo from './BadgeInfo/BadgeInfo'
import AuthRoutes from './Common/AuthRoutes'

import { Provider } from 'react-redux'
import store from '../store/store'
import AccessHistory from './AccessHistory/AccessHistory'

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Switch>
          <Route path='/login'>
            <Login />
          </Route>
          <Route path='/badge-info/:email/:title/:version' component={BadgeInfo} />

          <Route exact path='/user/:user' component={User} />
          <Route path='/' exact>
            <AuthRoutes>
              <Home />
            </AuthRoutes>
          </Route>
          <Route path='/issue'>
            <AuthRoutes>
              <IssueBadge />
            </AuthRoutes>
          </Route>
          <Route path='/all-badges'>
            <AuthRoutes>
              <AllBadges />
            </AuthRoutes>
          </Route>
          <Route path='/issuance-history'>
            <AuthRoutes>
              <AccessHistory />
            </AuthRoutes>
          </Route>
          <Route path='*'>404. Page Not Found</Route>
        </Switch>
      </Router>
    </Provider>
  )
}

export default App
